import React from 'react';
import PropTypes from 'prop-types';

import { Icon, Marker, Container } from './markerIcon.styles';
import { ICON_WINNOW_LOGO } from '../../../../shared/components/icon';

const MarkerIcon = ({ className }) => (
  <Container className={className}>
    <Marker />
    <Icon name={ICON_WINNOW_LOGO} size={36} />
  </Container>
);

MarkerIcon.propTypes = {
  className: PropTypes.string,
};

export default MarkerIcon;
